import { IOBuffer } from 'iobuffer';
import { isAnyArray } from 'is-any-array';

export async function setXYSpectrumData(file, spectra) {
  let ioBufferReal = file.re ? new IOBuffer(await file.re.arrayBuffer()) : null;
  let ioBufferImaginary = file.im
    ? new IOBuffer(await file.im.arrayBuffer())
    : null;
  let td = getDirectParameter(spectra.meta.SI);
  let swP = getDirectParameter(spectra.meta.SW_p);
  let sf = getDirectParameter(spectra.meta.SF);
  let bf = sf;
  let offset = getDirectParameter(
    spectra.shiftOffsetVal || spectra.meta.OFFSET,
  );
  spectra.meta.observeFrequency = sf;
  spectra.meta.brukerReference = bf;
  spectra.meta.DATATYPE = 'NMR Spectrum';

  let endian = parseInt(spectra.meta.BYTORDP, 10);
  endian = endian ? 0 : 1;

  let nbSubSpectra = spectra.meta.nbSubSpectra ? spectra.meta.nbSubSpectra : 1;
  if (endian) {
    if (file.re) ioBufferReal.setLittleEndian();
    if (file.im) ioBufferImaginary.setLittleEndian();
  } else {
    if (file.re) ioBufferReal.setBigEndian();
    if (file.im) ioBufferImaginary.setBigEndian();
  }

  for (let i = 0; i < nbSubSpectra; i++) {
    let toSave = {
      dataType: 'NMR Spectrum',
      nbPoints: td,
      firstX: offset,
      lastX: offset - swP / sf,
      xUnit: 'PPM',
      yUnit: 'Arbitrary',
      isXYdata: true,
      nucleus: spectra.meta.NUC1,
      observeFrequency: sf,
      title: spectra.meta.TITLE,
      deltaX: -(swP / sf) / (td - 1),
    };

    let deltaX = toSave.deltaX;
    let x = new Float64Array(td);
    let re = new Float64Array(td);
    let im = file.im ? new Float64Array(td) : null;

    if (im) {
      for (let k = 0; k < td; ++k) {
        x[k] = offset + k * deltaX;
        re[k] = ioBufferReal.readInt32();
        im[k] = ioBufferImaginary.readInt32();
      }
    } else {
      for (let k = 0; k < td; ++k) {
        x[k] = offset + k * deltaX;
        re[k] = ioBufferReal.readInt32();
      }
    }

    toSave.data = im ? { x, re, im } : { x, re };

    spectra.spectra.push(toSave);
  }
}

function getDirectParameter(meta) {
  return Number(isAnyArray(meta) ? meta[0] : meta);
}
